angular.module('SpidApp')

.factory('Inventory', [function () {
	var Inventory = function (params) {
		params 			= params || {}
		
		this.id				= params.id
		this.user_id		= params.user_id
		this.agency_id  	= params.agency_id
		this.type 			= params.type
		this.products  		= params.products
		this.diffStock		= params.diffStock
		this.diffInventory	= params.diffInventory
		this.updated_at		= params.updated_at
	}
	
	return Inventory
}])